import type { Translations } from '../types';

export const ko: Translations = {
  common: {
    home: '홈',
    github: 'GitHub',
    copy: '복사',
    clear: '지우기',
    input: '입력',
    output: '출력',
    encode: '인코딩',
    decode: '디코딩',
    generate: '생성',
    convert: '변환',
    result: '결과',
    copiedToClipboard: '클립보드에 복사되었습니다!',
    failedToCopy: '복사 실패',
    language: '언어',
  },
  seo: {
    siteDescription: '무료 개인정보 보호 중심 개발자 도구 모음. JSON 포맷터, Base64 인코더/디코더, UUID 생성기, 해시 생성기, URL 인코더, 타임스탬프 변환기, 색상 변환기. 모든 도구는 브라우저에서 오프라인으로 작동합니다.',
    keywords: [
      '개발자 도구',
      'JSON 포맷터',
      'Base64 인코더',
      'UUID 생성기',
      '해시 생성기',
      'URL 인코더',
      '타임스탬프 변환',
      '색상 변환기',
      '온라인 도구',
      '무료 도구',
      '개인정보 보호',
      '오프라인 도구',
    ],
    ogTitle: 'GetDev.Tools - 무료 개인정보 보호 개발자 도구',
    ogDescription: '브라우저에서 오프라인으로 작동하는 무료 개발자 도구 모음. JSON 포맷터, Base64, UUID, 해시, URL 인코더 등.',
  },
  home: {
    title: '개발자 도구 모음',
    subtitle: '무료 개인정보 보호 중심 개발자 도구. 모든 처리는 브라우저에서 이루어집니다.',
    whyTitle: 'GetDev.Tools를 선택하는 이유',
    privacyTitle: '🔒 개인정보 보호 우선',
    privacyDesc: '모든 처리는 브라우저에서 이루어집니다. 데이터가 기기를 떠나지 않습니다.',
    fastTitle: '⚡ 초고속',
    fastDesc: '서버 왕복 없음. 모든 작업이 로컬에서 실행되어 즉시 결과를 얻을 수 있습니다.',
    freeTitle: '🆓 영구 무료',
    freeDesc: '오픈 소스이며 무료로 사용할 수 있습니다. 등록이나 결제가 필요 없습니다.',
    footer: '© 2025 GetDev.Tools - 개인정보 보호 중심 개발자 도구',
    footerSubtitle: '모든 처리는 브라우저에서 이루어집니다',
  },
  tools: {
    jsonFormatter: {
      name: 'JSON 포맷터',
      description: 'JSON 데이터 포맷, 검증 및 정리',
      format: '포맷',
      minify: '압축',
      validate: '검증',
      error: '오류',
    },
    base64: {
      name: 'Base64 인코더/디코더',
      description: 'Base64 문자열 인코딩 및 디코딩',
      encodeButton: '인코딩',
      decodeButton: '디코딩',
    },
    uuid: {
      name: 'UUID 생성기',
      description: 'RFC 4122 준수 UUID v4 식별자 생성',
      numberOfUuids: '생성할 UUID 수',
      generatedUuids: '생성된 UUID',
      copyAll: '모두 복사',
      aboutTitle: 'UUID v4 정보',
      aboutDesc: 'UUID(범용 고유 식별자) v4는 무작위로 생성되는 128비트 식별자입니다. 충돌 확률이 극히 낮아 중앙 조정 없이 분산 시스템에 적합합니다.',
    },
    hash: {
      name: '해시 생성기',
      description: 'SHA-1, SHA-256, SHA-512 해시 생성',
      inputText: '입력 텍스트',
      securityNotice: '⚠️ 보안 알림',
      securityDesc: 'SHA-1은 보안상의 이유로 더 이상 사용되지 않습니다. 암호화 애플리케이션에는 SHA-256 또는 SHA-512를 사용하세요. MD5는 보안 취약점으로 인해 최신 브라우저에서 사용할 수 없습니다.',
    },
    urlEncoder: {
      name: 'URL 인코더/디코더',
      description: 'URL 문자열 인코딩 및 디코딩',
      encodeUrl: 'URL 인코딩',
      encodeComponent: '컴포넌트 인코딩',
      encoded: '인코딩됨',
      decoded: '디코딩됨',
      differenceTitle: '💡 차이점',
      encodeUriDesc: 'encodeURI: 전체 URI 인코딩 (인코딩하지 않음: ; , / ? : @ & = + $ #)',
      encodeComponentDesc: 'encodeURIComponent: URI 구성 요소 인코딩 (모든 특수 문자 인코딩)',
      examples: '예시',
    },
    timestamp: {
      name: '타임스탬프 변환기',
      description: 'Unix 타임스탬프와 사람이 읽을 수 있는 날짜 간 변환',
      currentTime: '현재 시간',
      unixMs: 'Unix 타임스탬프(밀리초)',
      unixS: 'Unix 타임스탬프(초)',
      toDate: '타임스탬프 → 날짜',
      toTimestamp: '날짜 → 타임스탬프',
      useNow: '현재 시간 사용',
      aboutTitle: '💡 Unix 타임스탬프 정보',
      aboutDesc1: '• Unix 타임스탬프 = 1970년 1월 1일 00:00:00 UTC(에포크) 이후 초',
      aboutDesc2: '• 10자리 = 초 (예: 1609459200)',
      aboutDesc3: '• 13자리 = 밀리초 (예: 1609459200000)',
      aboutDesc4: '• 지원되는 날짜 형식: ISO 8601, RFC 2822 또는 자연어',
    },
    color: {
      name: '색상 변환기',
      description: 'HEX, RGB, HSL 형식 간 변환',
      pickColor: '색상 선택',
      formatGuide: '💡 색상 형식 가이드',
      hexDesc: 'HEX: 16진수 표기법 (#RRGGBB)',
      rgbDesc: 'RGB: 빨강, 초록, 파랑 값 (0-255)',
      hslDesc: 'HSL: 색조 (0-360°), 채도 (0-100%), 명도 (0-100%)',
      alphaDesc: 'RGBA/HSLA: RGB/HSL과 동일하며 알파(불투명도) 채널 포함',
    },
    jwt: { name: 'JWT 디코더', description: 'JSON Web Token 디코딩 및 검사', inputToken: 'JWT 토큰', header: '헤더', payload: '페이로드', signature: '서명 (Base64)', claims: '표준 클레임', invalidFormat: 'JWT 형식이 잘못되었습니다', invalidToken: 'JWT 토큰이 잘못되었습니다', securityNotice: '보안 알림', securityDesc: '이 도구는 JWT 토큰을 디코딩만 합니다. 서명을 검증하지 않습니다.', aboutTitle: 'JWT에 대하여', aboutDesc1: 'JWT = JSON Web Token, 보안 인증에 사용', aboutDesc2: '형식: 헤더.페이로드.서명', aboutDesc3: '헤더에는 알고리즘, 페이로드에는 클레임 포함' },
    diff: { name: '텍스트 비교', description: '두 텍스트 블록 비교', originalText: '원본 텍스트', modifiedText: '수정된 텍스트', sideBySide: '나란히 보기', unified: '통합 보기', noDifference: '차이 없음' },
    markdown: { name: 'Markdown 미리보기', description: 'Markdown 실시간 작성 및 미리보기', editor: '편집기', preview: '미리보기', supportedFeatures: '지원: 제목, 목록, 링크, 이미지, 코드 블록, 표 등' },
    regex: { name: '정규식 테스터', description: '정규 표현식 테스트', pattern: '정규 표현식', flags: '플래그', testString: '테스트 문자열', matches: '일치 항목', noMatches: '일치 항목 없음', invalidRegex: '잘못된 정규식', globalFlag: '전역 (g)', caseInsensitive: '대소문자 구분 안 함 (i)', multiline: '여러 줄 (m)', dotAll: '점이 줄바꿈과 일치 (s)' },
    qrCode: { name: 'QR 코드 생성기', description: 'URL, 텍스트, WiFi 등의 QR 코드 생성', inputData: '입력 데이터', qrCodeImage: 'QR 코드 이미지', size: '크기 (픽셀)', errorCorrection: '오류 수정', errorLow: '낮음 (~7%)', errorMedium: '중간 (~15%)', errorQuartile: '높음 (~25%)', errorHigh: '최고 (~30%)', templates: '빠른 템플릿', templateUrl: '웹사이트 URL', templateEmail: '이메일', templatePhone: '전화번호', templateSms: 'SMS', templateWifi: 'WiFi 네트워크', templateVcard: '연락처 카드 (vCard)', privacyNotice: '🔒 개인정보 보호 알림', privacyDesc: 'QR 코드는 외부 API (qrserver.com)를 사용하여 생성됩니다. 데이터가 해당 서버로 전송됩니다.' },
    lorem: { name: 'Lorem Ipsum 생성기', description: '디자인 및 목업용 자리 표시자 텍스트 생성', generateType: '생성 유형', paragraphs: '단락', sentences: '문장', words: '단어', count: '개수', startWithLorem: '"Lorem ipsum"으로 시작', generatedText: '생성된 텍스트', aboutTitle: '💡 Lorem Ipsum 정보', aboutDesc: 'Lorem Ipsum은 디자인과 출판에서 일반적으로 사용되는 자리 표시자 텍스트입니다.' },
    htmlEntity: { name: 'HTML 엔티티 인코더', description: 'HTML 엔티티 인코딩 및 디코딩', inputText: '입력 텍스트', encodeBasic: '인코딩 (기본)', encodeAll: '모두 인코딩', decode: '디코딩', commonEntities: '일반 HTML 엔티티', character: '문자', entity: '엔티티', description2: '설명', useCases: '💡 사용 사례', useCase1: '기본 인코딩: 필수 문자만 인코딩 (<, >, &, ", \')', useCase2: '모두 인코딩: 최대 안전성을 위해 모든 특수 문자 인코딩', useCase3: '디코딩: HTML 엔티티를 일반 문자로 변환' },
  },
};

